export default __webpack_public_path__ + "static/media/userAssessmentImg.3be6a79b.svg";